import { render, staticRenderFns } from "./LinksEdit.vue?vue&type=template&id=32af2317&"
import script from "./LinksEdit.vue?vue&type=script&lang=js&"
export * from "./LinksEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports